import { useQuery } from "@tanstack/react-query";

import { makeApiRequest } from "../../utils";
import { COMMUNITY_REVIEWS_QUERY_KEY } from "../../../constants/queryKeys";

export const useFetchCommunityReview = ({ id }) => {
  return useQuery({
    queryKey: [COMMUNITY_REVIEWS_QUERY_KEY, `${id}`],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/communityReviews/${id}`,
        method: "GET"
      });
    },
    keepPreviousData: false
  });
};
